import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 1,
  style: {"padding":"20px"}
}
const _hoisted_2 = { class: "mt-20" }
const _hoisted_3 = { class: "mt-20" }
const _hoisted_4 = { class: "mt-20" }
const _hoisted_5 = { class: "mt-20" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "mt-40" }
const _hoisted_9 = { class: "mt-40 grid-5" }
const _hoisted_10 = { class: "color-disabled-text" }
const _hoisted_11 = { class: "color-disabled-text" }
const _hoisted_12 = { class: "color-disabled-text" }
const _hoisted_13 = { class: "color-disabled-text" }
const _hoisted_14 = { key: 1 }

import { onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from '@shell/composables/useI18n';

import Tab from '@shell/components/Tabbed/Tab';
import Tabbed from '@shell/components/Tabbed';
import { RcButton } from '@components/RcButton';
import { LabeledInput } from '@components/Form/LabeledInput';
import { BadgeState } from '@components/BadgeState';
import AsyncButton from '@shell/components/AsyncButton';
import { Banner } from '@components/Banner';
import FileSelector from '@shell/components/form/FileSelector';
import { usePrimeRegistration } from './registration.composable';
import Loading from '@shell/components/Loading.vue';

import { NAME as EXPLORER } from '@shell/config/product/explorer';
import { REGISTRATION_RESOURCE_NAME } from '../config/constants';


export default /*@__PURE__*/_defineComponent({
  __name: 'Registration',
  setup(__props) {

const store = useStore();
const { t } = useI18n(store);
const {
  downloadOfflineRequest,
  registration,
  registrationStatus,
  registerOnline,
  registerOffline,
  deregister,
  errors,
  initRegistration,
  registrationCode,
  registrationBanner
} = usePrimeRegistration();

/**
 * Track both registration types
 */
const isRegistered = computed(() => registrationStatus.value === 'registered');

/**
 * Track both registering progresses as generic operation to disable all the inputs
 */
const isRegistering = computed(() => registrationStatus.value === 'registering-online' || registrationStatus.value === 'registering-offline');

/**
 * Track offline registration progress, to switch between file selector and async button
 */
const isRegisteringOffline = computed(() => registrationStatus.value === 'registering-offline');

/**
 * Map link to router configuration
 */
const registrationLink = computed(() => ({
  name:   'c-cluster-product-resource-id',
  params: {
    cluster: 'local', product: EXPLORER, resource: REGISTRATION_RESOURCE_NAME, id: registration.value.id
  }
}));

const visitScc = () => window.open('https://scc.suse.com/register-offline/rancher', '_blank');

onMounted(async() => {
  initRegistration();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_clean_html = _resolveDirective("clean-html")!

  return (_unref(registrationStatus) === 'loading')
    ? (_openBlock(), _createBlock(Loading, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", null, _toDisplayString(_unref(t)('registration.title')), 1),
        _cache[20] || (_cache[20] = _createTextVNode()),
        _createVNode(_unref(Banner), {
          color: _unref(registrationBanner).type,
          "data-testid": "registration-banner-status"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)(_unref(registrationBanner).message)), 1)
          ]),
          _: 1
        }, 8, ["color"]),
        _cache[21] || (_cache[21] = _createTextVNode()),
        (_unref(errors).length)
          ? (_openBlock(), _createBlock(_unref(Banner), {
              key: 0,
              label: _unref(errors),
              color: "error",
              "data-testid": "registration-errors"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors), (error, i) => {
                  return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(error), 1))
                }), 128))
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _cache[22] || (_cache[22] = _createTextVNode()),
        _createVNode(_unref(Tabbed), null, {
          default: _withCtx(() => [
            _createVNode(_unref(Tab), {
              name: "online",
              label: _unref(t)('registration.online.title'),
              weight: 2
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("p", _hoisted_2, null, 512), [
                  [_directive_clean_html, _unref(t)('registration.online.description', {}, true)]
                ]),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createVNode(_unref(LabeledInput), {
                  value: _unref(registrationCode),
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(registrationCode) ? (registrationCode).value = $event : null)),
                  class: "mt-20",
                  disabled: isRegistered.value || isRegistering.value,
                  "label-key": "registration.online.input.label",
                  "placeholder-key": "registration.online.input.placeholder",
                  "data-testid": "registration-code-input"
                }, null, 8, ["value", "disabled"]),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _createVNode(_unref(AsyncButton), {
                  class: "mt-20",
                  waitingLabel: _unref(t)('registration.online.button-cta.progress'),
                  "action-label": _unref(t)('registration.online.button-cta.label'),
                  "success-label": _unref(t)('registration.online.button-cta.label'),
                  successColor: "role-primary",
                  "data-testid": "registration-online-cta",
                  disabled: isRegistered.value || isRegistering.value || !_unref(registrationCode),
                  onClick: _unref(registerOnline)
                }, null, 8, ["waitingLabel", "action-label", "success-label", "disabled", "onClick"])
              ]),
              _: 1
            }, 8, ["label"]),
            _cache[8] || (_cache[8] = _createTextVNode()),
            _createVNode(_unref(Tab), {
              name: "offline",
              label: _unref(t)('registration.offline.title'),
              weight: 1
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("p", _hoisted_3, null, 512), [
                  [_directive_clean_html, _unref(t)('registration.offline.stepone', {}, true)]
                ]),
                _cache[3] || (_cache[3] = _createTextVNode()),
                _createElementVNode("div", null, [
                  _createVNode(_unref(AsyncButton), {
                    class: "mt-20",
                    actionColor: "role-secondary",
                    successColor: "role-secondary",
                    waitingLabel: _unref(t)('registration.offline.button.download.progress'),
                    "action-label": _unref(t)('registration.offline.button.download.label'),
                    "success-label": _unref(t)('registration.offline.button.download.label'),
                    "data-testid": "registration-offline-download",
                    disabled: isRegistered.value,
                    onClick: _unref(downloadOfflineRequest)
                  }, null, 8, ["waitingLabel", "action-label", "success-label", "disabled", "onClick"])
                ]),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _withDirectives(_createElementVNode("p", _hoisted_4, null, 512), [
                  [_directive_clean_html, _unref(t)('registration.offline.steptwo', {}, true)]
                ]),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _createVNode(_unref(RcButton), {
                  secondary: "",
                  class: "mt-20",
                  "data-testid": "registration-offline-visit-scc",
                  disabled: isRegistered.value || isRegistering.value,
                  onClick: visitScc
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('registration.offline.button.visit.label')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _cache[6] || (_cache[6] = _createTextVNode()),
                _withDirectives(_createElementVNode("p", _hoisted_5, null, 512), [
                  [_directive_clean_html, _unref(t)('registration.offline.stepthree', {}, true)]
                ]),
                _cache[7] || (_cache[7] = _createTextVNode()),
                (isRegisteringOffline.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_unref(AsyncButton), {
                        class: "mt-20",
                        waitingLabel: _unref(t)('registration.offline.button.register.progress'),
                        "action-label": _unref(t)('registration.offline.button.register.label'),
                        "data-testid": "registration-offline-cta",
                        disabled: isRegistered.value || isRegistering.value,
                        currentPhase: isRegisteringOffline.value ? 'waiting' : 'success'
                      }, null, 8, ["waitingLabel", "action-label", "disabled", "currentPhase"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_unref(FileSelector), {
                        class: "role-primary mt-20",
                        label: _unref(t)('registration.offline.button.register.label'),
                        disabled: isRegistered.value || isRegistering.value,
                        accept: ".cert",
                        "data-testid": "registration-offline-cta",
                        onSelected: _unref(registerOffline)
                      }, null, 8, ["label", "disabled", "onSelected"])
                    ]))
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }),
        _cache[23] || (_cache[23] = _createTextVNode()),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h3", null, _toDisplayString(_unref(t)('registration.list.title')), 1),
          _cache[19] || (_cache[19] = _createTextVNode()),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('registration.list.table.header.status')), 1),
            _cache[9] || (_cache[9] = _createTextVNode()),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('registration.list.table.header.product')), 1),
            _cache[10] || (_cache[10] = _createTextVNode()),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('registration.list.table.header.expiration')), 1),
            _cache[11] || (_cache[11] = _createTextVNode()),
            _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('registration.list.table.header.mode')), 1),
            _cache[12] || (_cache[12] = _createTextVNode()),
            _cache[13] || (_cache[13] = _createElementVNode("div", null, null, -1)),
            _cache[14] || (_cache[14] = _createTextVNode()),
            _createElementVNode("div", null, [
              _createVNode(_unref(BadgeState), {
                label: _unref(t)(_unref(registration).message),
                color: 'bg-' + _unref(registration).color
              }, null, 8, ["label", "color"])
            ]),
            _cache[15] || (_cache[15] = _createTextVNode()),
            _createElementVNode("div", null, [
              (registrationLink.value)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    "data-testid": "registration-link",
                    to: registrationLink.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(registration).product), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(registration).product), 1))
            ]),
            _cache[16] || (_cache[16] = _createTextVNode()),
            _createElementVNode("div", null, _toDisplayString(_unref(registration).expiration), 1),
            _cache[17] || (_cache[17] = _createTextVNode()),
            _createElementVNode("div", null, _toDisplayString(_unref(registration).mode), 1),
            _cache[18] || (_cache[18] = _createTextVNode()),
            _createElementVNode("div", null, [
              _createVNode(_unref(AsyncButton), {
                waitingColor: "bg-error",
                actionColor: "bg-error",
                successColor: "bg-error",
                waitingLabel: _unref(t)('registration.list.table.button.progress'),
                "error-label": _unref(t)('registration.list.table.button.label'),
                "action-label": _unref(t)('registration.list.table.button.label'),
                "success-label": _unref(t)('registration.list.table.button.label'),
                "data-testid": "registration-deregister-cta",
                disabled: isRegistering.value || !isRegistered.value,
                onClick: _unref(deregister)
              }, null, 8, ["waitingLabel", "error-label", "action-label", "success-label", "disabled", "onClick"])
            ])
          ])
        ])
      ]))
}
}

})